import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { treatExperiment } from 'src/app/shared/api/experiments';
import { isMobile } from 'src/app/shared/utils/userAgent';

import type { PetitionDetailsDataExperimentsQuery } from '../experiments.graphql';

type Experiment = PetitionDetailsDataExperimentsQuery['experiments']['supporterGrowthEmbedSignPetitionFormExperiment'];

type Params = {
	experiment: Experiment;
	utilityContext: UtilityContext;
};

export async function normalizeSupporterGrowthEmbedSignPetitionFormExperiment({
	experiment,
	utilityContext,
}: Params): Promise<Experiment['variation']> {
	if (shouldRunExperiment({ experiment, utilityContext })) {
		await treatExperiment(utilityContext, experiment.experimentName);

		return experiment.variation;
	}

	return 'control';
}

function shouldRunExperiment({ experiment, utilityContext }: Params): boolean {
	return isEnabledByFC(experiment) && isMobile(utilityContext);
}

/**
 * The experiment in the GraphQL response is always an object. If there is no FC, or the experiment name in the FC is empty
 * or invalid, the experimentName property from GraphQL is set to '__invalid_experiment__' per the configuration in
 * packages/experiments/src/configs/configs/supporter_growth_embed_sign_petition_form_experiment.ts
 */
function isEnabledByFC(experiment: Experiment): boolean {
	return experiment.experimentName !== '__invalid_experiment__';
}
